import { render, staticRenderFns } from "./CrearProducto.vue?vue&type=template&id=3a7e69d3&"
import script from "./CrearProducto.vue?vue&type=script&lang=js&"
export * from "./CrearProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports